import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Address\DeleteAddressController::deleteMethod
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/{address}'
*/
export const deleteMethod = (args: { address: string | number } | [address: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/address/{address}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::deleteMethod
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/{address}'
*/
deleteMethod.url = (args: { address: string | number } | [address: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { address: args }
    }

    if (Array.isArray(args)) {
        args = {
            address: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        address: args.address,
    }

    return deleteMethod.definition.url
            .replace('{address}', parsedArgs.address.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::deleteMethod
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/{address}'
*/
deleteMethod.delete = (args: { address: string | number } | [address: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::undo
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/address/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::undo
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::undo
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Address\DeleteAddressController::undo
* @see app/Http/Controllers/Address/DeleteAddressController.php
* @route '/api/address/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteAddressController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteAddressController